import { defineMessages, useIntl } from "react-intl";

import {
  queryClient,
  MutationActions,
  QueryKeys,
  useEntityMutation,
} from "@/api/core";
import { useAdjust } from "@/contexts/adjust-context";
import { useApi } from "@/hooks";
import { statusSchema } from "@/schemas";
import toast from "@/toast";

import { updateStatusCache } from "../utils";

const messages = defineMessages({
  deletedTruth: {
    id: "status.error.deletedTruth",
    defaultMessage: "This Truth has been deleted and is no longer available.",
  },
});

interface Variables {
  id: string;
}

function useFavouriteStatus() {
  const intl = useIntl();
  const api = useApi();
  const { trackEngagement } = useAdjust();

  return useEntityMutation({
    globalQueryKey: QueryKeys.statuses.global,
    idAttributeFromVariables: "id",
    action: MutationActions.UPDATE,
    schema: statusSchema,
    skipOnSuccess: true, // TODO: Remove once API added optimistic updates.
    mutationFn: (variables: Variables) =>
      api.post(`/api/v1/statuses/${variables.id}/favourite`),
    onMutate(variables) {
      const [prevStatus] = updateStatusCache(variables.id, (prevStatus) => ({
        favourited: true,
        favourites_count: prevStatus.favourites_count + 1,
      }));

      trackEngagement("like");

      return { prevStatus };
    },
    onError(error, variables, context) {
      if (error.response?.status === 404) {
        toast.error(intl.formatMessage(messages.deletedTruth));
      }
      if (context) {
        queryClient.setQueryData(
          QueryKeys.statuses.detail(variables.id),
          context.prevStatus,
        );
      }
    },
  });
}

export { useFavouriteStatus };
